<script>
import { euroCouponsRequestCouponMethods } from '@state/helpers'
import DeleteItem from '@components/euro_coupons/item/Delete'

export default {
  name: 'EuroCouponsRequestCouponDetail',
  components: { DeleteItem},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    deleteAction:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      sending: false,
      showDelete: false,
      toDelete: {},
      downloading: false,
      tableHeaders: [],
      toDetail: {},
    }
  },
  computed: {},

  beforeMount() {
    this.tableHeaders = [
      {
        key: 'unit_value',
        label: this.$t('unit_value'),
        formatter: (value) => {
          return this.$formatDollar(value)
        },
      },
      {
        key: 'quantity',
        label: this.$t('quantity'),
        formatter: (value) => {
          return this.$formatDollar(value)
        },
      },
      {
        key: 'total',
        label: this.$t('total'),
        formatter: (value) => {
          return this.$formatDollar(value)
        },
      },
      // {
      //   key: 'actions',
      //   label: this.$t('actions'),
      //   formatter: (value) => {
      //     return this.$formatDollar(value)
      //   },
      // },
    ]

    
      if (this.deleteAction) {
        this.tableHeaders = [...this.tableHeaders,
          ...[
            { key: 'actions', label: this.$t('actions') },
          ]
        ]
      }
  },

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.toDetail = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.oncancel()
    }
  },

  methods: {
    ...euroCouponsRequestCouponMethods,

    getObject() {
      let context = this
      const promise = context.fetchEuroCouponsRequestCouponDetail(
        context.toDetail.url
      )
      return promise
        .then((data) => {
          context.toDetail = { ...data }
          context.loading = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loading = false
          context.oncancel()
        })
    },

    sendReport() {
      let context = this
      context.sending = true
      const promise = context.sendReportEuroCouponsRequestCoupon(
        context.toDetail.url
      )
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('request_coupon')} ${context.$t('sent')} ${context.$t(
              'correctly'
            )}`
          )
          context.sending = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.sending = false
        })
    },
    getReport() {
      let context = this
      context.downloading = true
      const promise = context.getReportEuroCouponsRequestCoupon({ 
          url : context.toDetail.url,
          type: { responseType: 'arraybuffer' }
      })
      return promise
        .then((response) => {
            const data = response
            const url = URL.createObjectURL(
              new Blob([data], {
                type: 'application/vnd.ms-excel',
              })
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Reporte de solicitud de bonos.xlsx`)
            document.body.appendChild(link)
            link.click()
            context.downloading = false
          })
          .catch((error) => {
            context.downloading = false
              console.error(error)
              context.$axios_error_noty('Se presento un error en la descarga del archivo.', )
          })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="`${$t('detail_of')} ${$t('request_coupon')}`"
    size="lg"
    ok-title="Cerrar"
    ok-variant="primary rounded"
    ok-only
    @hidden="oncancel"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col class="d-flex justify-content-end mb-1">
          <b-button
            variant="outline-primary rounded-lg  mx-1 shadow"
            :disabled="downloading"
            @click="getReport"
          >
            <b-spinner v-if="downloading" small label="Spinning"></b-spinner>
            <i v-else class="fas fa-download"></i>
          </b-button>
          <b-button
            variant="outline-primary rounded-lg shadow"
            :disabled="sending"
            @click="sendReport"
          >
            <b-spinner v-if="sending" small label="Spinning"></b-spinner>
            <i v-else class="far fa-paper-plane"></i> </b-button
        ></b-col>

        <b-col md="12">
          <b-list-group class="mb-3 border border-primary shadow">
            <b-list-group-item
              v-if="toDetail.purchase_order"
              class="d-flex justify-content-between align-items-center"
            >
              <b class="text-primary"
                ><i class="fas fa-file-invoice"></i>
                {{ $t('purchase_order') }}</b
              >
              <b-badge variant="primary" style="font-size: 13px">{{
                toDetail.purchase_order
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              <b class="text-primary"
                ><i class="fas fa-user-tag"></i>
                {{ $t('thirdparty') }}</b
              >
              <b-badge variant="primary" style="font-size: 13px">{{
                toDetail.user_detail ? toDetail.user_detail.thirdparty_name : ''
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              <b class="text-primary"
                ><i class="fas fa-user-alt"></i> {{ $t('request_by') }}
              </b>
              <b-badge variant="light" style="font-size: 13px">{{
                toDetail.user_detail ? toDetail.user_detail.username : ''
              }}</b-badge>
            </b-list-group-item>

            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              <b class="text-primary"
                ><i class="fas fa-calendar-day"></i> {{ $t('date') }}</b
              >
              <b-badge variant="light" style="font-size: 13px">{{
                toDetail.request_date
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              <b class="text-primary"
                ><i class="fas fa-dollar-sign"></i>
                {{ $t('total_amount') }}</b
              >
              <b-badge variant="light" style="font-size: 13px">{{
                this.$formatDollar(toDetail.value)
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              v-if="toDetail.items.length"
            >
              <b class="text-primary"
                ><i class="fas fa-list-alt"></i>
                {{ $t('items_detail') }}</b
              >
              <b-col md="8" class="shadow-sm border rounded m-3 bg-light">
                <b-table
                  v-if="toDetail.items.length"
                  hover
                  :items="toDetail.items"
                  :fields="tableHeaders"
                  :thead-class="[
                    'text-primary',
                    'border-primary',
                    'border-bottom-c',
                  ]"
                >
                <template v-slot:cell(actions)="row">
                <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                  <i class="far fa-trash-alt"></i>
                  </b-button>
                </template>
                </b-table>
              </b-col>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
    <DeleteItem
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          getObject()
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {}
        }
      "
    >
    </DeleteItem>
  </b-modal>
</template>
<style lang="scss">
</style>